import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLeading } from 'redux-saga/effects';
import { requestForbiddenAuto } from 'modules/fetch/api';

const FORBIDDEN_AUTO_GET = 'forbiddenAuto/FORBIDDEN_AUTO_GET';

export const forbiddenAuto = createAction(FORBIDDEN_AUTO_GET);

const initialize = {
  forbiddenAutoList: [],
};

export function* getForbiddenList(action) {
  try {
    const result = yield call(requestForbiddenAuto, action.payload);

    yield put({ type: FORBIDDEN_AUTO_GET, payload: result.data });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}


export function* forbiddenAutoSaga() {
  yield takeLeading(FORBIDDEN_AUTO_GET, getForbiddenList);
}


export default handleActions(
  {
    [FORBIDDEN_AUTO_GET]: (state, { payload: forbiddenAutoList }) => {
      return { ...state, forbiddenAutoList };
    },
  },
  initialize
);
